import { consola } from 'consola'

export default defineNuxtPlugin(() => {
  if (process.env.NODE_ENV === 'development') {
    return
  }

  consola.options.reporters = []
  consola.addReporter({
    log(logObj) {
      const gelfPayload = {
        version: "1.1",
        host: process.env.HOSTNAME || "nuxt-app",
        short_message: typeof logObj.args[0] === 'string' ? logObj.args[0] : 'Structured log',
        full_message: JSON.stringify(logObj.args),
        timestamp: Date.now() / 1000,
        level: mapConsolaToSyslog(logObj.type),
        _type: logObj.type,
        _tag: logObj.tag,
        _channel: process.env.GELF_CHANNEL_NAME || "stokvis-frontend",
      }

      process.stdout.write(JSON.stringify(gelfPayload) + '\n')
    }
  })
})

function mapConsolaToSyslog(type) {
  const levels = {
    error: 3,
    warn: 4,
    info: 6,
    debug: 7,
    trace: 7
  }
  return levels[type] || 6
}
